import React from 'react';
import { Box, Typography } from '@mui/material';
import type { LegalBlock } from '../../services/legalService';

export function LegalBlocks({ blocks }: { blocks: LegalBlock[] }) {
  return (
    <Box>
      {(blocks || []).map((block, index) => {
        if (block.type === 'h') {
          return (
            <Typography key={index} variant="h6" gutterBottom sx={{ mt: index === 0 ? 0 : 2 }}>
              {block.text}
            </Typography>
          );
        }
        if (block.type === 'ul') {
          return (
            <Box key={index} component="ul" sx={{ pl: 3, my: 1 }}>
              {block.items.map((item, i) => (
                <li key={i}>
                  <Typography variant="body2" component="span">
                    {item}
                  </Typography>
                </li>
              ))}
            </Box>
          );
        }
        return (
          <Typography key={index} variant="body2" paragraph>
            {block.text}
          </Typography>
        );
      })}
    </Box>
  );
}
